import { cn } from "@pcln/horizon";
const cruiseFormVariants = {
    default: {
        gridContainer: [
            'grid grid-cols-1 gap-3',
            '@3xl:grid-cols-6',
            '@7xl:grid-cols-[minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)_max-content]',
            "@3xl:[grid-template-areas:'destination_destination_destination_departure_departure_departure'_'length_length_line_line_search_search']",
            '@7xl:[grid-template-areas:unset]'
        ]
    }
};
const getGridContainerClass = ()=>cn(cruiseFormVariants.default.gridContainer, 'mx-auto');
const getSubmitButtonClass = (isMobile)=>{
    if (isMobile) return 'fixed bottom-4 right-4 left-4 @3xl:[grid-area:search]';
    return 'w-full @3xl:[grid-area:search] @7xl:[grid-area:unset] @7xl:col-span-1';
};
const inputClassMap = {
    destination: '@3xl:[grid-area:destination] @7xl:[grid-area:unset]',
    departure: '@3xl:[grid-area:departure] @7xl:[grid-area:unset]',
    length: '@3xl:[grid-area:length] @7xl:[grid-area:unset]',
    line: '@3xl:[grid-area:line] @7xl:[grid-area:unset]'
};
const getInputClass = (type)=>inputClassMap[type];
export { getGridContainerClass, getInputClass, getSubmitButtonClass };
